// Чистая геометрия квадратного кропа изображения (ImageCropper). Вынесена из компонента:
// jsdom не умеет canvas/layout, а математику клампа/пересчёта покрываем юнитами (SPEC §6).
//
// Модель: квадратный вьюпорт V×V, картинка natural W×H рисуется с масштабом s и смещением
// (ox, oy) — координаты ЛЕВОГО-ВЕРХНЕГО угла картинки относительно вьюпорта. Инвариант: картинка
// всегда полностью накрывает вьюпорт (нет «дыр»), т.е. s ≥ coverScale и смещение зажато.
/** Минимальный масштаб: картинка полностью накрывает вьюпорт (аналог object-fit: cover). */
export function coverScale(naturalW, naturalH, viewport) {
    if (naturalW <= 0 || naturalH <= 0)
        return 1;
    return Math.max(viewport / naturalW, viewport / naturalH);
}
/** Зажать смещение так, чтобы вьюпорт не выехал за картинку. */
export function clampOffset(ox, oy, naturalW, naturalH, scale, viewport) {
    const w = naturalW * scale;
    const h = naturalH * scale;
    // левый край ≤ 0, правый край ≥ viewport
    const minX = viewport - w;
    const minY = viewport - h;
    return {
        ox: Math.min(0, Math.max(minX, ox)),
        oy: Math.min(0, Math.max(minY, oy)),
    };
}
/**
 * Зум вокруг центра вьюпорта: пересчитывает смещение так, чтобы точка под центром осталась
 * на месте, затем клампит. nextScale уже должен быть ≥ coverScale (вызывающий гарантирует).
 */
export function zoomAroundCenter(ox, oy, scale, nextScale, naturalW, naturalH, viewport) {
    const c = viewport / 2;
    // точка картинки (в natural-координатах) под центром вьюпорта
    const px = (c - ox) / scale;
    const py = (c - oy) / scale;
    return clampOffset(c - px * nextScale, c - py * nextScale, naturalW, naturalH, nextScale, viewport);
}
/** Исходный прямоугольник кропа в natural-координатах картинки (для canvas.drawImage). */
export function cropSourceRect(ox, oy, scale, viewport) {
    return { sx: -ox / scale, sy: -oy / scale, size: viewport / scale };
}
//# sourceMappingURL=crop.js.map